// TODO: move LeadAccordion, LeadAccordionSummary, LeadAccordionDetails to @avenue-8/sidekick-ui
import styled from "@emotion/styled";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@avenue-8/sidekick-ui";

export const LeadAccordion = styled(Accordion)`
  &.MuiAccordion-root {
    background: transparent;
  }
`;

export const LeadAccordionSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    padding: 0;
    max-height: 100%;
    min-height: 100%;
    background: transparent;
    padding-bottom: 0.5rem;

    &:hover {
      background: transparent;
    }

    &.Mui-expanded {
      max-height: 100%;
      min-height: 100%;
    }
  }

  .MuiAccordionSummary-content {
    margin: 0;
    text-transform: capitalize;
  }

  .MuiAccordionSummary-expandIconWrapper {
    color: inherit;
  }
`;

export const LeadAccordionDetails = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    padding: 0 0.5rem 0.75rem 0;
    background: transparent;
    border: none;
    border-top: none;
  }
`;
